import API from '../config/config-api';

export const getCustomers = () => {
  return API().get('customer')
    .then(response => response.data)
    .catch(err => { throw err; });
};


// WEBPACK FOOTER //
// ./src/api/customer-service.js